import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
} from '@mui/material';
import {
  Description as DraftIcon,
  CloudSync as GhostTrafficIcon,
  Inventory as PackageIcon,
  Storage as StorageIcon,
  Dns as RegistryIcon,
  CompareArrows as ValidationIcon,
} from '@mui/icons-material';
import { DraftManager } from './DraftManager';
import { GhostTrafficManager } from './GhostTrafficManager';
import { PackageManager } from './PackageManager';
import { AssetManager } from './AssetManager';
import { OCIRegistryBrowser } from './OCIRegistryBrowser';
import { AssetValidationPanel } from './AssetValidationPanel';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`rangeos-tabpanel-${index}`}
      aria-labelledby={`rangeos-tab-${index}`}
      style={{ height: '100%' }}
      {...other}
    >
      {value === index && (
        <Box sx={{ height: '100%' }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export const RangeOSContentManager: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Sub-tabs header */}
      <Box sx={{
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        px: 2,
      }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ minHeight: 48 }}
        >
          <Tab
            label="Draft Scenarios"
            icon={<DraftIcon />}
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
          <Tab
            label="Scenarios & Packages"
            icon={<PackageIcon />}
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
          <Tab
            label="Ghost Traffic"
            icon={<GhostTrafficIcon />}
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
          <Tab
            label="Assets"
            icon={<StorageIcon />}
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
          <Tab
            label="Registries"
            icon={<RegistryIcon />}
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
          <Tab
            label="Validation"
            icon={<ValidationIcon />}
            iconPosition="start"
            sx={{ minHeight: 48 }}
          />
        </Tabs>
      </Box>

      {/* Tab content */}
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <TabPanel value={activeTab} index={0}>
          <DraftManager />
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <PackageManager />
        </TabPanel>
        <TabPanel value={activeTab} index={2}>
          <GhostTrafficManager />
        </TabPanel>
        <TabPanel value={activeTab} index={3}>
          <AssetManager />
        </TabPanel>
        <TabPanel value={activeTab} index={4}>
          <OCIRegistryBrowser />
        </TabPanel>
        <TabPanel value={activeTab} index={5}>
          <AssetValidationPanel />
        </TabPanel>
      </Box>
    </Box>
  );
};
